import { hydrateWidgets } from '@utils';
import { Storefront } from '../../widgets/Explore/DVWebNodeStorefront';
hydrateWidgets(Storefront);
